import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from '@inplayer-org/inplayer-ui';
import { FaPercent, FaUnlockAlt } from 'react-icons/fa';
import { GoDeviceMobile } from 'react-icons/go';

// types
import { VoucherTypeName } from 'pages/MerchantPages/Assets/Vouchers/shared/sharedTypes';

// components
import { getVoucherDetails } from 'ducks/merchantDucks/vouchers/selectors';

interface Props {
  type?: string;
  id?: string | number;
}

const VoucherTypeIcon: FunctionComponent<Props> = ({ type: propType, id: propId }) => {
  const { type, id } = useSelector(getVoucherDetails);
  const voucherType = propType || type;
  const voucherId = propId || id;

  switch (voucherType) {
    case VoucherTypeName.Web:
      return (
        <Tooltip tag={`table_icon_voucher_type_${voucherId}`} placement="right" content="Discount voucher">
          <FaPercent />
        </Tooltip>
      );
    case VoucherTypeName.Vip:
      return (
        <Tooltip tag={`table_icon_voucher_type_${voucherId}`} placement="right" content="Access voucher">
          <FaUnlockAlt />
        </Tooltip>
      );
    case VoucherTypeName.InApp:
      return (
        <Tooltip tag={`table_icon_voucher_type_${voucherId}`} placement="right" content="In-app voucher">
          <GoDeviceMobile />
        </Tooltip>
      );
    default:
      return null;
  }
};

export default VoucherTypeIcon;
